var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-col',{staticClass:"footer__logo-container footer__col",attrs:{"sm":"2","cols":"12","align":_vm.alignment}},[_c('a',{attrs:{"href":`https://www.lausanne-tourisme.ch/${_vm.locale}`}},[_c('img',{staticClass:"footer__logo",attrs:{"src":_vm.logo,"alt":"logo"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }